exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-especial-dates-template-jsx": () => import("./../../../src/templates/especial-dates-template.jsx" /* webpackChunkName: "component---src-templates-especial-dates-template-jsx" */)
}

